import { CompanyData, FetchStatus } from 'types/api';
import { useState } from 'react';
import { isAxiosError } from 'axios';
import { registerModuleApi } from 'modules/RegisterModule/api';

export const useRegisterCompany = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [errors, setError] = useState({
    name: '',
    link: '',
    industry: '',
    employees_num: '',
    mission: '',
    website_link: '',
  });
  const [hasCompany, setHasCompany] = useState(false);

  const registerCompany = async (data: CompanyData) => {
    try {
      setStatus('loading');
      const dataPayload = {
        ...data,
        employees_num: Number(data.employees_num),
      };
      await registerModuleApi.registerCompany(dataPayload);
      setStatus('success');
    } catch (error) {
      setStatus('failed');
      if (isAxiosError(error)) {
        if (
          error.response?.status === 400 &&
          error.response.data.toString() === 'User already has a company'
        ) {
          setHasCompany(true);
        }

        const data = error.response?.data as Partial<
          Record<keyof typeof errors, string[]>
        >;

        const formattedErrors = Object.entries(data || {}).reduce<
          Record<string, string>
        >((acc, [key, value]) => {
          if (Array.isArray(value)) {
            acc[key] = value.join(', ');
          }
          return acc;
        }, {});
        setError((previous) => ({ ...previous, ...formattedErrors }));
      }
    }
  };
  return { hasCompany, status, errors, registerCompany };
};
